import {
  Component,
  OnInit,
  AfterViewInit,
  PLATFORM_ID,
  Inject
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { isPlatformBrowser } from '@angular/common';
import { CoreConfigService } from '../core/core.service';
@Component({
  selector: 'kett-banner',
  templateUrl: '../banner-form/banner-form.component.html',
  styleUrls: ['../banner-form/banner-form.component.css'],
})
export class BannerFormComponent implements OnInit {
  constructor(private _HttpClient: HttpClient,
    private _CoreConfigService: CoreConfigService,
    @Inject(PLATFORM_ID) private platformId: any
  ) { 

    if (isPlatformBrowser(this.platformId)) {
      this.GetBannerDetail().subscribe(
        (response) => {
          if (response && Array.isArray(response.data)) {
            const banners = response.data;
            const output = document.getElementById('swippy');
            if (output) {
              banners.forEach(item => {
                if (item.attributes) {
                  const attributes = item.attributes;
                  const linkURL = attributes.actionUrlEn ? true : false;
                  const actionUrl = attributes.actionUrlEn ? attributes.actionUrlEn : '#';
                  const imageUrl = attributes.imageUrlEn ? attributes.imageUrlEn : '#';
                  var landmark = '';
                  
                  if(linkURL){
                  var landmark = '<div class="swiper-slide" style="text-align: center;"><a href="'+ actionUrl +'" target="_blank" rel="noreferrer noopener"><img  src="'+imageUrl+'"></img></a></div>'; 
                  }else{
                  var landmark = '<div class="swiper-slide" style="text-align: center;"><img src="'+imageUrl+'"></img></div>'; 
                  }
                   output.innerHTML += landmark;
                }
              });

              $('.swiper-button-next').show();
              $('.swiper-button-prev').show();

              var swiper = new Swiper('.swiper', {
                spaceBetween: 50,
                centeredSlides: true,
                slidesPerView: 1,
                loop: true,
                autoplay: {
                  delay: 10000,
                  disableOnInteraction: false,
                },
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                  1024: {
                    slidesPerView: 1.5,
                    spaceBetween: 50,
                  },
                },
              });

            }

          }
        }
      );
    }

  }
  ngOnInit(): void {

  }

  GetBannerDetail(): Observable<any>{
    const url = 'https://th.kex-express.com/track/api/Shipment/GetBanner';
    return this._HttpClient.get(url);
  }

  
}